var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === false)?_c('div',{staticClass:"poster-poster"},[_c('div',{staticClass:"poster",on:{"touchstart":_vm.start}},[_c('img',{attrs:{"src":_vm.image}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }